import "@quark/design/dist/index.css";
import "../index.css";

export default function MyApp({ Component, pageProps }) {
  return <Component {...pageProps} />;
}
